import { SizeType } from 'antd/es/config-provider/SizeContext';
import classNames from 'classnames';
import React, { FC, memo } from 'react';
import styled, { css } from 'styled-components';
import { prop, switchProp } from 'styled-tools';

type CustomSizeType = SizeType | 'xsmall';

interface Props extends React.PropsWithChildren {
  className?: string;
  icon: React.ReactNode;
  size?: CustomSizeType;
  dataTestId?: string;
}

const Shell = styled.div<{ size: CustomSizeType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  ${switchProp(prop('size', 'middle'), {
    middle: css`
      height: var(--input-height-default);
      min-width: var(--input-height-default);
      width: var(--input-height-default);
    `,
    small: css`
      height: var(--input-size-sm);
      min-width: var(--input-size-sm);
      width: var(--input-size-sm);
    `,
    large: css`
      height: var(--input-height-lg);
      min-width: var(--input-height-lg);
      width: var(--input-height-lg);
    `,
    xsmall: css`
      height: var(--input-size-xs);
      min-width: var(--input-size-sm);
      width: var(--input-size-sm);
    `,
  })};
`;

export const IconShell: FC<Props> = (props) => {
  const { icon, size = 'middle', className, dataTestId } = props;

  return (
    <Shell
      size={size}
      className={classNames('icon-shell', className)}
      data-cy={dataTestId}
    >
      {icon}
    </Shell>
  );
};

export const IconWrapper = styled.span`
  color: var(--icon-primary);
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const MemoedIconShell = memo(IconShell);
